import classNames from 'classnames';

export default function DefaultContentTemplatePartnership({
  partnership,
  className,
  isDefaultContentTemplate = false,
}: {
  partnership?: string;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <div
      className={classNames('flex flex-wrap gap-4', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      <p className="text-sh-xxs text-[#4E4E4E]">
        In partnership with <strong>{partnership}</strong>
      </p>
    </div>
  );
}
